import { render } from "./ProductsInStockPage.vue?vue&type=template&id=4c3dbe4f&lang=pug"
import script from "./ProductsInStockPage.vue?vue&type=script&lang=js"
export * from "./ProductsInStockPage.vue?vue&type=script&lang=js"

import exportComponent from "/builds/chiedocover/chiedohome.com/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__